// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","xl":"1200px","header":"Collapse_header__szFfW"};